import entry from './entry';
import { peek } from 'vega-util';
export default function (enc) {
  var code = '';
  enc.forEach(function (rule) {
    var value = entry(rule);
    code += rule.test ? "(".concat(rule.test, ")?").concat(value, ":") : value;
  });

  // if no else clause, terminate with null (#1366)
  if (peek(code) === ':') {
    code += 'null';
  }
  return code;
}